import React from 'react'
import { Block, Pill } from '@components'

const DatoCmsPill = ({ paddingTop, paddingBottom, ...props }) => {
  return (
    <Block gutters paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Pill {...props} />
    </Block>
  )
}

export default DatoCmsPill
